import { render, staticRenderFns } from "./add-country-data.vue?vue&type=template&id=10600747"
import script from "./add-country-data.vue?vue&type=script&lang=ts"
export * from "./add-country-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports